// SimpleButton.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React, { useRef } from 'react';
import { Button } from 'antd';
import { useSimpleFormContext } from './SimpleFormProvider';
import { useModuleContext } from '../core/ModuleProvider';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// FUNCTIONS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleButton = ({
  // API principal
  type = 'primary',
  title = 'save',
  icon,
  loading = false,
  disabled = false,
  onClick,
  htmlType, // opcional: força 'submit' | 'button' | 'reset'
  block = true,

  // aparência
  style = { width: 116 },
  className,
  size, // 'small' | 'middle' | 'large'
  shape, // 'default' | 'circle' | 'round'
  ghost = false,
  danger = false,

  // extras
  name, // mantido por consistência com o padrão, não utilizado
  ...props
}) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { locked, disabledFields } = useSimpleFormContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────
  const clickGuardRef = useRef(false);

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const isDisabled = disabled || locked || loading || disabledFields?.includes(name);
  const resolvedHtmlType = htmlType || (typeof onClick === 'function' ? 'button' : 'submit');

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleClick = async evt => {
    // evita cliques duplos enquanto executa
    if (clickGuardRef.current || isDisabled) return;
    if (!onClick) return; // quando não há onClick, o submit do form assume
    try {
      clickGuardRef.current = true;
      await onClick(evt);
    } finally {
      clickGuardRef.current = false;
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Button
      type={type}
      icon={icon}
      className={className}
      style={style}
      htmlType={resolvedHtmlType}
      block={block}
      loading={loading}
      disabled={isDisabled}
      onClick={handleClick}
      size={size}
      shape={shape}
      ghost={ghost}
      danger={danger}
      {...props}
    >
      <span>{translateX(title)}</span>
    </Button>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleButton;
